import { type Field, type Section } from '@/lib/types';

const createdAtMatchesModelVisibilityDates = (
  createdAt: string,
  { visibleFrom, visibleUntil }: Field | Section,
): boolean => {
  if (visibleFrom === null && visibleUntil === null) {
    return true;
  }

  if (visibleFrom === null) {
    return createdAt <= visibleUntil!;
  }

  if (visibleUntil === null) {
    return createdAt >= visibleFrom;
  }

  return createdAt >= visibleFrom && createdAt <= visibleUntil;
};

export default createdAtMatchesModelVisibilityDates;
